import React, { useContext, useState, useEffect } from 'react';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { D as Drawer } from '../../Drawer-XTMo2WsL.js';
import { useTranslation } from 'react-i18next';
import { selectCart } from '../../storeSelectors/cart.js';
import { selectYmals } from '../../storeSelectors/ymal.js';
import { getReactivateCartSessionId, reactivateCart, getCartSessionId } from '../../utils/cart.js';
import { removeCookie } from '../../utils/cookies.js';
import { h as COOKIE_REACTIVATE_CART_SESSION_ID } from '../../cookies-l-jEMp6P.js';
import { CoreContext } from '../../context/index.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import '../../index-zNO-4REJ.js';
import 'next/router';
import useShowError from '../../hooks/useShowError.js';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import 'lodash';
import 'lodash/cloneDeep';
import '../../utils/price.js';
import '../../index-2586sEvh.js';
import 'next/link';
import 'react-hook-form';
import '../../validationSchema-SF-U2-Ri.js';
import 'lodash/debounce';
import { S as ShoppingCartDrawer } from '../../ShoppingCartDrawer-VanUspF4.js';
export { S as CartDrawerButton } from '../../CartDrawerButton-2eYmUV78.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../OnlyUIRender/index.js';
import 'react-dom';
import '../../hooks/useAnimate.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'cookies-next';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../../hooks/useWindowSize.js';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../requestsCollection-gritD79O.js';
import 'graphql-request';
import '../../services/auth/index.js';
import '../../utils/currency.js';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/product.js';
import '../../utils/logger.js';
import '../../paths-ZKN3m62_.js';
import '../../cart-Vtx0Wqgk.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/error.js';
import '../../utils/logToRelic.js';
import 'number-currency-format';
import '../../utils/isBot.js';
import 'i18next';
import '../../index-V63xQvL7.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../../validation-AjMAVn7m.js';
import '../../ShoppingCartContentDrawer-BWVf5gOL.js';
import '../../cart-bEN0otWy.js';
import '../../checkout-lyccjd9h.js';
import '../../cart-SVV9q5Ln.js';
import '../Button/index.js';
import '../CircularProgress/index.js';
import '../Link/index.js';
import '../ButtonGroup/index.js';
import '../../ShoppingCartItemDrawer-_a_KPs--.js';
import '../../hooks/useItemListName.js';
import '../../utils/dataRouteFormat.js';
import '../Loader/index.js';
import '../../Quantity-fA-KAokk.js';
import '../../QuantityForm-oomCO568.js';
import '../ShoppingCart/ShoppingCartContentDrawer/ShoppingCartItemDrawer/Quantity/QuantityForm/form/index.js';
import '../inputs/InputQuantity/index.js';
import '../inputs/AutoSubmit/index.js';
import '../../Remove-yBvNmlSV.js';
import '../../store/modal/index.js';
import '@reduxjs/toolkit';
import '../../store/modal/initialState.js';
import '../../FeaturedProducts-5IF9TQe3.js';
import '../../a11y-f6LwtRzd.js';
import '../../FeaturedProductItem-kXu6-t9-.js';
import '../../Prices-J1SqTpik.js';
import '../../selectItem-PWuzvZX7.js';
import '../WishlistButton/index.js';
import '../../storeSelectors/user.js';
import '../../storeSelectors/wishlist.js';
import '../../localStorage-h6SlcHvK.js';
import '../../hooks/useShowNotify.js';
import '../Modal/index.js';
import '../Modal/ModalContent/index.js';
import '../../hooks/useAutoFocus.js';
import '../Modal/ModalHeader/index.js';
import '../../SwiperActions-zQ1VhslW.js';
import '../../Skeleton-RKr5mJai.js';
import '../../FeaturedProductSkeleton-dpwqH2FM.js';
import '../../featuredProducts-00rJtoMw.js';
import '../../ShoppingCartDrawerSkeleton-kCFrECX9.js';
import '../../CartItemDrawerSkeleton-pSF-OxYE.js';
import '../../hooks/usePageViewEvent.js';
import '../../pageView-EPLyidHy.js';
import '../../utils/auth.js';
import '../../storeSelectors/category.js';
import '../../storeSelectors/product.js';
import '../../types-nwm8HIz7.js';

const CartDrawer = ({ isOpen, onClose }) => {
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { data: { locale, siteConfig: { accorTagging: { accorTaggingEnabled = false } = {} }, }, useDispatch, useSelector, apolloConfig, thunks: { cart: { getCart }, ymal: { getYmal }, }, } = useContext(CoreContext);
    const [isLoading, setIsLoading] = useState(true);
    const [isYmalLoading, setIsYmalLoading] = useState(true);
    const dispatch = useDispatch();
    const showError = useShowError();
    const cart = useSelector(selectCart);
    const ymal = useSelector(selectYmals);
    const quantity = cart.total_quantity;
    const onMount = async () => {
        setIsLoading(true);
        const reactivateCartSessionId = getReactivateCartSessionId();
        if (reactivateCartSessionId) {
            const reactivateCartStatus = await reactivateCart(reactivateCartSessionId, apolloConfig);
            if (!reactivateCartStatus.success) {
                if (reactivateCartStatus.isCartIdNotFound) {
                    setIsLoading(false);
                }
                removeCookie(COOKIE_REACTIVATE_CART_SESSION_ID);
            }
        }
        const cartSessionId = getCartSessionId();
        const fetchCart = !cartSessionId || cart.has_fetched;
        try {
            setIsLoading(true);
            setIsYmalLoading(true);
            const cartPromise = !fetchCart
                ? dispatch(getCart({ cart_id: cartSessionId, accorTaggingEnabled }))
                : Promise.resolve(null);
            const ymalPromise = !ymal.has_fetched ? dispatch(getYmal()) : Promise.resolve(null);
            const [cartResult, ymalResult] = await Promise.all([cartPromise, ymalPromise]);
            if (cartResult && getCart.rejected.match(cartResult)) {
                showError(cartResult.payload.errorMessage);
            }
            if (ymalResult && getYmal.rejected.match(ymalResult)) {
                showError(ymalResult.payload.errorMessage);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('An error occurred while fetching data:', error);
        }
        finally {
            setIsLoading(false);
            setIsYmalLoading(false);
        }
    };
    useEffect(() => {
        if (isOpen) {
            onMount();
        }
    }, [locale, isOpen]);
    return (React.createElement(Drawer, { open: isOpen, onClose: onClose, name: "shopping-cart" },
        React.createElement("div", { "data-testid": "cart", id: "shopping-cart-drawer" },
            React.createElement("h2", { className: "title", "data-testid": "cart-items-amount" },
                tHeading('shoppingCart'),
                " ",
                React.createElement(React.Fragment, null,
                    "(",
                    quantity,
                    ")")),
            React.createElement(ShoppingCartDrawer, { isLoading: isLoading, isYmalLoading: isYmalLoading }))));
};
var CartDrawer$1 = withProviders(CartDrawer, { translation: true, snackbar: true });

export { CartDrawer$1 as default };
//# sourceMappingURL=index.js.map
